// src/utils/googleAuth.js
// Pre-initializes Google Sign-In as soon as the GSI script loads.
// By the time user reaches login page, Google is already ready.

let _clientId = null;
let _callback = null;
let _initialized = false;

function waitForGoogle(cb, tries = 0) {
  if (window.google?.accounts?.id) {
    cb();
  } else if (tries < 40) {
    setTimeout(() => waitForGoogle(cb, tries + 1), 100);
  }
}

// Called once from index.js on app start
export function initGoogleAuth(clientId) {
  if (!clientId || _initialized) return;
  _clientId = clientId;

  waitForGoogle(() => {
    _initialized = true;
    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: (response) => {
        if (_callback && response?.credential) {
          _callback(response.credential);
        }
      },
      auto_select: false,
      cancel_on_tap_outside: true,
      ux_mode: 'popup',
    });
  });
}

// Renders Google button into container div immediately
export function renderGoogleButton(clientId, container, onSuccess, onError) {
  if (!clientId || !container) return;
  _callback = onSuccess;

  const doRender = () => {
    if (!window.google?.accounts?.id) {
      onError && onError('Google Sign-In unavailable. Please use email.');
      return;
    }

    // Re-initialize with latest callback
    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: (response) => {
        if (response?.credential) {
          onSuccess(response.credential);
        }
      },
      auto_select: false,
      cancel_on_tap_outside: true,
      ux_mode: 'popup',
    });

    window.google.accounts.id.renderButton(container, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'rectangular',
      logo_alignment: 'left',
      width: Math.min(container.offsetWidth || 400, 400),
    });
  };

  // If GSI already loaded, render immediately — no waiting
  if (window.google?.accounts?.id) {
    doRender();
  } else {
    waitForGoogle(doRender);
  }
}

export function handleGoogleRedirectCallback() {
  try {
    const hash = window.location.hash.substring(1);
    if (!hash) return null;
    const params = new URLSearchParams(hash);
    const idToken = params.get('id_token');
    if (!idToken) return null;
    const returnPath = sessionStorage.getItem('google_oauth_return') || '/dashboard';
    sessionStorage.removeItem('google_oauth_state');
    sessionStorage.removeItem('google_oauth_return');
    window.history.replaceState({}, document.title, window.location.pathname);
    return { credential: idToken, returnPath };
  } catch {
    return null;
  }
}